import type { IdentitiesSelectionData, IdentitiesSelectionIdentity } from "@/services/SavingsPlanOnboarding.types";
import type { UserIdentityDetailDto } from "@/services/UserIdentitiesService";
import { IntervenerRelation } from "@/screen/ContractManagement/helpers/intervenerSelectionHelpers";
import { IdentityEditPath } from "@/screen/Identities/identitiesRoutes";

export const MinorToAdultGateStepKeys = ["2.2.1", "2.4"];
export const MinorToAdultDataStepKey = "2.4.1";

export function isMinorToAdultGateStep(key: string | null | undefined): boolean
{
    return key != null && MinorToAdultGateStepKeys.includes(key);
}

// Espejo de GetNowAdultOwnerLink (IroniaApi): el titular OWNER que ya no es menor.
export function findNowAdultOwner(selection: IdentitiesSelectionData | null | undefined): IdentitiesSelectionIdentity | null
{
    const ownerIds = (selection?.assignments ?? [])
        .filter((assignment) => assignment.relation === IntervenerRelation.Owner)
        .map((assignment) => assignment.userIdentityId);

    return selection?.userIdentities.find((identity) => ownerIds.includes(identity.id) && !identity.isMinor) ?? null;
}

export function formatIdentityFullName(identity: Pick<IdentitiesSelectionIdentity, "firstName" | "lastName" | "secondLastName">): string
{
    return [identity.firstName, identity.lastName, identity.secondLastName].filter(Boolean).join(" ").trim();
}

function hasValue(value: string | number | boolean | null | undefined): boolean
{
    return value !== null && value !== undefined && value !== "";
}

// Espejo de IsMinorToAdultDataComplete (IroniaApi). Con datos incompletos Holder no transforma y manda un email.
export function isMinorToAdultDataComplete(detail: UserIdentityDetailDto | null | undefined): boolean
{
    if(!detail)
    {
        return false;
    }

    return hasValue(detail.phone)
        && hasValue(detail.email)
        && detail.hasProofOfIncome
        && hasValue(detail.economicActivity)
        && hasValue(detail.publicPosition)
        && hasValue(detail.gafiQuestion);
}

export function buildMinorToAdultDataEditLocation(userIdentityId: number, savingsPlanId: number, savingsPlanName?: string): {pathname: string; search: string}
{
    const params = new URLSearchParams(
    {
        contractFlow: "true",
        savingsPlanId: String(savingsPlanId),
    });
    if(savingsPlanName)
    {
        params.set("savingsPlanName", savingsPlanName);
    }

    return{
        pathname: `${IdentityEditPath}/${userIdentityId}`,
        search: `?${params.toString()}`,
    };
}
